<template>
  <transition name="modal-backdrop-transition" appear>
    <div class="o-backdrop" @click="close()">
      <button
        type="button"
        class="modal__close --is-mobile-close"
        @click.stop="close()"
        v-if="$store.getters.isMobile"
      >
        <i class="icon icon-times"></i>
      </button>
      <transition name="modal-content-transition" appear>
        <div class="modal --is-content product-detail single-product-detail" @click.stop>
          <div class="modal__scrollable">
            <!-- modal hero -->
            <div class="product-detail__hero">
              <div class="row">
                <div class="kol-xs-12 kol-sm-6">
                  <div class="single-product-detail__gallery" ref="gallery">
                    <div ref="glide" class="glide">
                      <div class="glide__track" data-glide-el="track">
                        <ul class="glide__slides">
                          <li
                            v-for="(slide, index) in getImages()"
                            :key="index"
                          >
                            <img
                              :srcset="`
                                ${slide}?format=${webPFormat('jpeg')}&width=1000&nearlossless=1 1000w,
                                ${slide}?format=${webPFormat('jpeg')}&width=500&nearlossless=1 500w
                              `"
                              sizes="
                                (max-width: 36em) 100vw,
                                31em
                              "
                              :src="`${slide}?format=${webPFormat('jpeg')}&width=500&nearlossless=1`"
                            >
                          </li>
                        </ul>
                      </div>
                    </div>

                    <ul class="product-detail__thumbnails" data-glide-el="controls[nav]">
                      <li
                        v-for="(slide, index) in getImages()"
                        :key="index"
                        :data-glide-dir="`=${index}`"
                      >
                        <img
                          :src="`${slide}?format=${webPFormat('jpeg')}&width=120&nearlossless=1`"
                        >
                      </li>
                    </ul>

                    <div class="single-product-detail__controls" data-glide-el="controls">
                      <button type="button" data-glide-dir="<"><i class="icon icon-angle-left"></i></button>
                      <button type="button" data-glide-dir=">"><i class="icon icon-angle-right"></i></button>
                    </div>
                  </div>
                </div>

                <div class="kol-xs-12 kol-sm-6">
                  <div class="product-detail__overview">
                    <small
                      class="product-detail__level"
                      v-if="$store.getters.getModalItem.type === 'level_1'"
                    >
                      <span
                        v-for="(tag, index) in $store.getters.getModalItem.tags"
                        :key="tag.term_id"
                      >
                        {{ tag.name }}
                        <span
                          v-if="
                            index !==
                            $store.getters.getModalItem.tags.length - 1
                          "
                          >·&nbsp;</span
                        >
                      </span>
                    </small>
                    <small
                      class="product-detail__level product-detail__item-vendor"
                      v-else-if="$store.getters.getModalItem.type === 'product'"
                    >
                      <span v-html="productDetailStringVar1Bold1($store.getters.getModalItem)" class="product-detail__item-vendor"></span>
                    </small>

                    <h2
                      class="product-detail__title"
                      v-if="$store.getters.getModalItem.type === 'level_1'"
                    >
                      {{ $store.getters.getModalItem.name }}
                    </h2>
                    <h2
                      class="product-detail__title"
                      v-else-if="$store.getters.getModalItem.type === 'level_3'"
                    >
                      Übersicht Ihrer individuell zusammengestellten Präsent-Komposition
                    </h2>
                    <h2 class="product-detail__title" v-else>
                      {{ $store.getters.getModalItem.name }}
                    </h2>
                    <small
                      class="product-detail__level product-detail__item-vendor --push-up"
                      v-if="$store.getters.getModalItem.type === 'product'"
                    >
                      <span>
                        von
                        {{ $store.getters.getModalItem.manufacturer }}
                      </span>
                    </small>

                    <div
                      v-if="$store.getters.getModalItem.type === 'product'"
                      class="product-detail__description"
                      v-html="$store.getters.getModalItem.short_description"
                    ></div>
                    <div
                      v-else
                      class="product-detail__description"
                      v-html="$store.getters.getModalItem.description"
                    ></div>

                    <ul
                      class="product-detail__fearures"
                      v-if="
                        ($store.getters.getModalItem.type === 'level_1' && ($store.getters.isB2b || (!$store.getters.isB2b && level1CompleteStock($store.getters.getModalItem)))) ||
                        $store.getters.getModalItem.type === 'level_3'
                      "
                    >
                      <DeliveryTime :time="calculatedTime" :type="'li'" />
                    </ul>

                    <ul
                      v-if="$store.getters.getModalItem.type === 'level_1' || $store.getters.getModalItem.type === 'level_3'"
                      class="box-content__inside-list --no-left-padding --half-margin-top"
                    >
                      <li>Edle Geschenkverpackung mit Magnetverschluss</li>
                      <li>Hochwertige Grußkarte mit vielfältigen Motiven</li>
                      <li>Von uns handgeschrieben mit Ihrer persönlichen Nachricht.</li>
                      <li class="--no-before">
                        <a
                        href="https://componata.de/das-auspack-erlebnis-header/"
                      >
                        Details zum Auspack-Erlebnis anzeigen
                      </a>
                      </li>
                    </ul>

                    <div
                      class="product-detail__cta"
                      v-if="$store.getters.getModalItem.type === 'level_1'"
                    >
                      <Button
                        appearance="primary"
                        v-if="
                          ($store.getters.getSelectedItem.data === null ||
                          $store.getters.getModalItem.id !==
                            $store.getters.getSelectedItem.data.id) && ($store.getters.isB2b || (!$store.getters.isB2b && level1CompleteStock($store.getters.getModalItem)))
                        "
                        @click="addToBox()"
                        >Auswählen</Button
                      >
                      <div v-else-if="
                          ($store.getters.getSelectedItem.data === null ||
                          $store.getters.getModalItem.id !==
                            $store.getters.getSelectedItem.data.id)" style="margin-right: 10px;">
                        <Button appearance="secondary" @click="close()">Zurück zur Übersicht</Button><br>
                        <small>derzeit nicht verfügbar</small>
                      </div>

                      <div class="product-detail__price">
                        <Price>
                          <template v-slot:brutto>{{ humanPrice(getPriceRawForGroup($store.getters.getModalItem, $store.getters.getUserGroupId, false) + getBoxPriceLvl1($store.getters.getModalItem, $store.getters.getUserGroupId, false)) }}</template>
                          <template v-slot:netto>{{ humanPrice(getPriceRawForGroup($store.getters.getModalItem, $store.getters.getUserGroupId, true) + getBoxPriceLvl1($store.getters.getModalItem, $store.getters.getUserGroupId, true)) }}</template>
                        </Price>
                      </div>
                    </div>
                    <div
                      class="product-detail__cta"
                      v-else-if="
                        $store.getters.getModalItem.type === 'product' &&
                        $store.getters.getLevel3Helper[
                          $store.getters.getModalItem.id
                        ] &&
                        ($store.getters.getCurrentLevel === 3 ||
                          $route.name.startsWith('Confirm'))
                      "
                    >
                      <Button
                        appearance="primary"
                        v-if="
                          $store.getters.getLevel3Helper[
                            $store.getters.getModalItem.id
                          ].placeable &&
                          $route.name !== 'ConfirmModalProduct'
                        "
                        @click="
                          addLevel3($store.getters.getModalItem);
                          $router.push(
                           cLink('/zusammenstellen')
                          );
                        "
                        >Hinzufügen</Button
                      >

                      <span
                        v-else-if="
                          $route.name !== 'ConfirmModalProduct'
                        "
                        style="margin-right: 10px"
                      >
                        <i class="icon icon-ban"></i>
                        Leider ist nicht mehr genug Platz für diese Köstlichkeit.
                      </span>

                      <div class="product-detail__price">
                        <Price align="left">
                          <template v-slot:brutto>{{ humanPrice(getPriceRawForGroup($store.getters.getModalItem, $store.getters.getUserGroupId, false)) }}</template>
                          <template v-slot:netto>{{ humanPrice(getPriceRawForGroup($store.getters.getModalItem, $store.getters.getUserGroupId, true)) }}</template>
                        </Price>
                      </div>
                    </div>
                    <div
                      class="product-detail__cta"
                      v-else-if="$store.getters.getModalItem.type === 'level_3'"
                    >
                      <div class="product-detail__price">
                        <Price align="left">
                          <template v-slot:brutto>{{ humanPrice(getPriceRawForGroup($store.getters.getModalItem, $store.getters.getUserGroupId, false)) }}</template>
                          <template v-slot:netto>{{ humanPrice(getPriceRawForGroup($store.getters.getModalItem, $store.getters.getUserGroupId, true)) }}</template>
                        </Price>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /modal hero -->

            <!-- modal body content -->
            <div
              class="product-detail__body"
              v-if="
                $store.getters.getModalItem.type === 'level_1' ||
                $store.getters.getModalItem.type === 'level_3'
              "
            >
              <div class="row center-xs">
                <div class="kol-xs-12 kol-lg-7">
                  <h3>Inhalt dieser liebevoll zusammengestellten Präsent-Konfiguration</h3>
                  <p>&nbsp;</p>

                  <ul class="product-detail__items">
                    <li
                      class="product-detail__item"
                      v-for="product in getListProducts()"
                      :key="product.product"
                    >
                      <div class="product-detail__item-pic">
                        <img
                          :src="product.photos[$store.getters.groupAbb][0].thumbnail"
                          :alt="product.name"
                        />
                      </div>

                      <div class="product-detail__item-info">
                        <h6
                          v-if="product.product"
                          class="product-detail__item-title"
                        >
                          {{ product.name }}
                        </h6>
                        <h6
                          v-else
                          class="product-detail__item-title"
                        >
                          {{ product.name }}
                        </h6>
                        <span v-html="productDetailStringBold1(product)" class="product-detail__item-vendor"></span>

                        <div
                          v-html="product.short_description"
                          class="product-detail__item-description"
                        ></div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              class="product-detail__body"
              v-else-if="
                $store.getters.getModalItem.type === 'product' &&
                $store.getters.getModalItem.description !== ''
              "
            >
              <h3>Produktbeschreibung</h3>
              <div
                v-html="$store.getters.getModalItem.description"
                class="product-detail__item-description"
              ></div>
            </div>
            <!-- /modal body content -->

            <!-- modal body content -->
            <div class="product-detail__body --is-white">
              <h3>Herstellerinformationen und Nährwertangaben</h3>

              <div class="product-detail__legal-info">
                <LegalInfo :item="$store.getters.getModalItem" />
              </div>
            </div>
            <!-- /modal body content -->
          </div>

          <button
            type="button"
            class="modal__close"
            @click.stop="close()"
            v-if="!$store.getters.isMobile"
          >
            <i class="icon icon-times"></i>
          </button>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
/* eslint-disable no-unused-vars */
import { calculateDeliveryTimeForProduct } from '@/helper/functions';

import Glide from '@glidejs/glide';

import Button from '@/components/Common/Button';
import LegalInfo from '@/components/LegalInfo';
import Price from '@/components/Common/Price';
import DeliveryTime from '@/components/Common/DeliveryTime';
import { logicMixin } from '@/mixins/LogicMixin';
import { helperMixin } from '@/mixins/HelperMixin';

export default {
  name: 'Modal',
  components: {
    Button,
    LegalInfo,
    Price,
    DeliveryTime,
  },
  mixins: [logicMixin, helperMixin],
  data: function () {
    return {
      allImagesLoaded: false,
      calculatedTime: 0,
      glide: null,
      galleryOptions: {
        type: 'slider',
        autoplay: 5000,
        startAt: 0,
        perView: 1,
        gap: 0,
        bound: true,
        classes: {
          nav: {
            active: '--is-active'
          }
        }
      }
    };
  },
  created: function () {
    this.getImages();
    // Add here time for delivery
    var addForChristmas = 0;
    if ([62, 2569, 2571, 2548].includes(parseInt(this.$store.getters.getUserGroupId))) {
      addForChristmas = 0;
    }
    this.calculatedTime = this.getDeliveryTime(
      this.$store.getters.getModalItem
    ) + addForChristmas;
  },
  methods: {
    close: function () {
      if (
        this.$route.name === 'ConfirmModalProduct'
      ) {
        this.$router.push(
          this.cLink('/zusammenfassung')
        );
      } else if (
        this.$route.name === 'ConfiguraterLevel3ModalProduct'
      ) {
        this.$router.push(
          this.cLink('/zusammenstellen')
        );
      } else if (
        this.$route.name === 'ProposalPageProductDetail'
      ) {
        this.$router.push(
          this.cLink('/proposal/' + this.$route.params.id)
        );
      } else if (
        this.$route.name === 'CustomerLandingPageProductDetail'
      ) {
        this.$router.push(
          this.cLink('/business/' + this.$route.params.id)
        );
      } else if (this.$route.name === 'CatalogPresentPageProductDetail') {
        this.$router.push(
          this.cLink('/fertige/' + this.$route.params.boxId)
        );
      } else {
        if (this.$store.getters.getModalItem.type === 'level_1') {
          if (this.$store.getters.getSelectedItem.data === null) {
            this.$router.push(
              this.cLink('/fertige')
            );
          } else {
            this.$router.push(
              this.cLink('/fertige/' +
                this.$store.getters.getSelectedItem.data.id)
            );
          }
        }
      }
    },
    getImages: function () {
      var images = [];
      if (this.$store.getters.getModalItem.type === 'level_3') {
        this.$store.getters.getModalItem.products.forEach((info) => {
          images.push(info.photos[this.$store.getters.groupAbb][0].original);
        });
      } else if (this.$store.getters.getModalItem.type === 'level_1' || this.$store.getters.getModalItem.type === 'product') {
        this.$store.getters.getModalItem.photos[this.$store.getters.groupAbb].forEach((image) => {
          images.push(image.original);
        });
      }

      return images;
    },
    addToBox: function () {
      this.$router.push(
        this.cLink('/fertige/' +
          this.$store.getters.getModalItem.id)
      );
    },
    getDeliveryTime: function (item) {
      var time = 0;
      if (
        this.$store.getters.getCurrentLevel === 1 &&
        item.products
      ) {
        item.products.forEach((product) => {
          if (product.replaced) {
            product = product.replaceData;
          }
          const tempTime = calculateDeliveryTimeForProduct(
            product,
            this.$store.getters.getSelectedQty,
            this.$store.getters.getSettings
          );
          if (tempTime > time) {
            time = tempTime;
          }
        });
      } else if (this.$store.getters.getCurrentLevel === 3) {
        time = calculateDeliveryTimeForProduct(
          item,
          this.$store.getters.getSelectedQty,
          this.$store.getters.getDelTimeSettings
        );
      }

      return time;
    },
    getListProducts: function () {
      var products = [];
      this.$store.getters.getModalItem.products.forEach((product) => {
        if (product.type === 'product') {
          if (product.replaced) {
            products.push(product.replaceData);
          } else {
            products.push(product);
          }
        }
      });

      return products;
    },
    getSeoInfo: function() {
      return {
        title: 'Geschenkkörbe online bestellen oder selber zusammenstellen - Componata'
      };
    },
    escKeyHandler (e) {
      if (this.$store.getters.getModalOpen && e.keyCode === 27) {
        this.close();
      }
    }
  },
  mounted: function () {
    this.glide = new Glide(this.$refs.gallery, this.galleryOptions);
    this.glide.mount();

    // Esc key for closing modal
    document.addEventListener('keydown', this.escKeyHandler, { once: true });
  },
  destroyed () {
    document.removeEventListener('keydown', this.escKeyHandler);

    if (this.glide) {
      this.glide.destroy();
    }
  },
  metaInfo() {
    return this.getSeoInfo();
  }
};
</script>

<style lang="scss" scoped>
@import '~@glidejs/glide/src/assets/sass/glide.core';

/**
 * Single Product Detail
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Single product detail
 * @since 2022-04-10
**/

$component: 'single-product-detail';

.#{$component} {
  // …

  &__gallery {
    position: relative;

    .glide__slides li {
      img {
        display: block;
        width: 100%;
        cursor: zoom-in;
      }
    }
  }

  &__controls {
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 40%;
    width: 100%;
    pointer-events: none;

    button {
      margin: 0;
      padding: 0;
      border: none;
      background: none;
      outline: none;
      color: $ink-lightest;
      @include font-size($icon-size-base * 3);
      line-height: 1;
      pointer-events: all;

      &:active {

      }
    }
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__gallery {
      @include margin-bottom(map-get($spacers, 3));
    }
  }
}
</style>

<style lang="scss">
@import '../assets/styles/components/modal';
@import '../assets/styles/components/product-detail';
@import '../assets/styles/components/box-content-inside-list';
@import '../assets/styles/components/slider';
</style>
